import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const deletePpeComponent = (id) => {
    return axios.delete(`${apiurl?.deletePpeComponentMaster}/${id}`);
};

    const deletePpeComponentMaster = () => {
        const queryClient = useQueryClient();
        return useMutation(deletePpeComponent, {
            onSuccess: () => {
                showAlert('PPE Component Deleted Successfully!', 'success');
                queryClient.invalidateQueries('getAllPpeComponentMaster');
            },
            onError: (error) => {
              showAlert(error?.response?.data, 'error');
            }
        });
    };

export default deletePpeComponentMaster;
